import * as MITO from '@mitojs/web'
import moment from 'moment'
import { axios } from '@/utils/request'
import createMD5 from 'js-md5'
import store from '@/store'
import { getUserInfo } from '@/api/login'

function getBuriedKey (appCode) {
  return axios({
    url: process.env.VUE_APP_DNS + '/appCode/getKey?appCode=' + appCode, // 获取埋点key
    method: 'get'
  })
}
// eslint-disable-next-line max-params
export async function mitoLog (path = '', pathName = '', tag = 'route', buttonName = '', dataName = '') {
  const username = store.state.user.name
  const userId = store.state.user.userId
  let companyName = localStorage.getItem('qiaocai_pc_companyName')
  const appCode = process.env.VUE_APP_CODE
  let BuriedKey = localStorage.getItem('qiaocai_pc_BuriedKey')
  if (!BuriedKey) {
    const res = await getBuriedKey(appCode)
    if (res.result) {
      localStorage.setItem('qiaocai_pc_BuriedKey', res.result)
      BuriedKey = res.result
    }
  }
  if (!companyName && userId) {
    const res = await getUserInfo({ id: userId })
    if (res.code === '0' && res.data) {
      companyName = res.data.employeeInfo.company
      localStorage.setItem('qiaocai_pc_companyName', companyName)
    } else {
      companyName = ''
    }
  }
  if (BuriedKey && username) {
    const random = parseInt(Math.random() * 1000000).toString().substr(0, 6)
    const body = [
      {
        s100: moment().format('YYYY-MM-DD'),
        s220: username,
        s210: companyName,
        s300: appCode,
        s310: 'v1.0.0',
        s320: process.env.VUE_APP_NAME,
        s330: process.env.VUE_APP_PLATFORM,
        s340: process.env.VUE_APP_ENV,
        s404: 'Browser',
        s502: path,
        s503: tag,
        s504: pathName,
        s510: pathName,
        s505: dataName,
        S531: buttonName,
        s600: moment().format('YYYY-MM-DD HH:mm:ss'),
        s641: window.history.state.forward ? 'B' : 'F'
      }
    ]
    const md5 = createMD5(`appCode=${appCode}&date=${moment().format('YYYYMMDDHHmmss')}&nonce=${random}${BuriedKey}`)
    MITO.log({
      tag,
      message: {
        body,
        appCode: appCode,
        date: moment().format('YYYYMMDDHHmmss'),
        nonce: random,
        sign: `${md5}`
      }
    })
  }
}
